export default __webpack_public_path__ + "static/media/Presentation_Image.3bf080cf.png";